import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Order extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            ORDER: false,
            PRINT_PRODUCTS: [],
            datetime: false
        }
    }

    componentDidMount = () => {
        this.fetchOrderData()
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    todayDate = () => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        return dd + '.' + mm + '.' + yyyy
    }

    todayDatetime = () => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        var hours = String(today.getHours()).padStart(2, '0');
        var minutes = String(today.getMinutes()).padStart(2, '0');
        var seconds = String(today.getSeconds()).padStart(2, '0');

        return dd + '.' + mm + '.' + yyyy + ' ' + hours + ':' + minutes + ':' + seconds + ':'
    }

    prepareStickers = () => {
        if (!this.state.PRINT_PRODUCTS.length) {
            return;
        }

        let stickers = [];

        for (let i = 0; i < this.state.PRINT_PRODUCTS.length; i++) {
            let product = this.state.PRINT_PRODUCTS[i]

            stickers.push({
                id: product.id,
                supplier: this.state.USER.title,
                title: product.title,
                weight: product.weight,
                sostav: product.sostav,
                storage: product.storage_text,
                barcode: product.barcode,
                ed_izm: product.ed_izm,
                klet: product.klet,
                fats: product.fats,
                calories: product.calories,
                ugl: product.ugl,
                bel: product.bel,
                manufactured: this.todayDate(),
                manufactured_with_time: this.state.datetime ? this.state.datetime.replace('T', ' ') + ':00' : this.todayDatetime(),
                print_amount: parseInt(product.amount),
                order_id: this.state.ORDER.id,
                placement_cell: product.placement_cell
            })
        }

        function compare(a, b) {
            if (a.title < b.title) {
                return -1;
            }
            if (a.title > b.title) {
                return 1;
            }
            return 0;
        }

        stickers.sort(compare);

        localStorage.setItem('productsStickers', JSON.stringify(stickers));
        window.open('/print_mass_qr', '_blank').focus()
    }

    fetchOrderData = async () => {
        let id = this.props.match.params.id;

        try {
            let SEND_DATA = {
                action: 'supplierOrderData',
                id: id,
                supplier_apikey: this.props.USER.supplier_apikey
            };

            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.setState({ ORDER: data, LOADED: true });
            } else {
                this.setState({ LOADED: true });
            }
        } catch (error) {
        }
    }

    saveOrderData = async () => {
        let id = this.props.match.params.id;

        try {
            let SEND_DATA = {
                action: 'supplierConfirmOrder',
                id: id,
                delivery_date: this.state.ORDER.delivery_date,
                delivery_time: this.state.ORDER.delivery_time,
                products: this.state.ORDER.products,
                supplier_apikey: this.props.USER.supplier_apikey
            };

            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.fetchOrderData();
                this.props.fetchPendingOrders(+ new Date())
                this.props.history.push('/orders')
            } else {
            }
        } catch (error) {
        }
    }

    cancelOrder = async () => {
        let id = this.props.match.params.id;

        try {
            let SEND_DATA = {
                action: 'supplierCancelOrder',
                id: id,
                supplier_apikey: this.props.USER.supplier_apikey
            };

            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.fetchOrderData();
                this.props.fetchPendingOrders(+ new Date())
            } else {
            }
        } catch (error) {
        }
    }

    renderStatusBadge = (status) => {
        let title = 'Новый';
        let className = 'new';

        switch (parseInt(status)) {
            case 1:
                title = 'На согласовании';
                className = 'talk';
                break;
            case 2:
                title = 'Ожидание поставки';
                className = 'waiting';
                break;
            case 3:
                title = 'Отменён';
                className = 'cancelled';
                break;
            case 4:
                title = 'Принят';
                className = 'done';
                break;
        }

        return <span className={ 'order_status ' + className }>{ title }</span>
    }

    renderIntroBlock = () => {
        let dateTimeBlock = false;
        if (parseInt(this.state.ORDER.status) == 2 && this.state.PRINT_PRODUCTS.length > 0) {
            dateTimeBlock = (
                <input type="datetime-local" className="datetimeQrInput" onChange={ (e) => this.setState({ datetime: e.target.value }) } />
            )
        }

        return (
            <div className="order_head">
                { this.renderStatusBadge(this.state.ORDER.status) }
                <div className="order_static_row">
                    Дата заказа: { this.state.ORDER.order_date }
                </div>
                <div className="order_static_row">
                    Дата поставки: { this.state.ORDER.delivery_date }
                </div>
                { this.state.ORDER.comment.length ?
                    <div className="order_static_row">
                        Комментарий: { this.state.ORDER.comment }
                    </div>
                    : null }
                { parseInt(this.state.ORDER.status) == 2 ? <a onClick={ () => this.prepareStickers() } className={ this.state.PRINT_PRODUCTS.length == 0 ? ' small_btn disabled' : 'small_btn' }>Сформировать этикетки ({ this.state.PRINT_PRODUCTS.length } тов)</a> : null }
                { dateTimeBlock }
            </div>
        );
    }

    renderImage = (PRODUCT) => {
        let SRC = PRODUCT.images.thumb;
        if ((typeof SRC !== "undefined") && (SRC !== "")) {
            return (
                <img
                    className="product_image"
                    src={ CONFIG.API_C_DOMAIN + SRC }
                />
            );
        }

        return false;
    }

    changePrice = (price, id) => {
        let ORDER = Object.assign({}, this.state.ORDER)

        for (let i = 0; i < ORDER.products.length; i++) {
            if (ORDER.products[i].id == id) {
                ORDER.products[i].supplier_price = price
            }
        }

        this.setState({ ORDER: ORDER })
    }

    changeAmount = (amount, id) => {
        let ORDER = Object.assign({}, this.state.ORDER)

        for (let i = 0; i < ORDER.products.length; i++) {
            if (ORDER.products[i].id == id) {
                ORDER.products[i].supplier_amount = amount
            }
        }

        this.setState({ ORDER: ORDER })
    }

    toggleConfirmation = (id) => {
        let ORDER = Object.assign({}, this.state.ORDER)

        for (let i = 0; i < ORDER.products.length; i++) {
            if (ORDER.products[i].id == id) {
                ORDER.products[i].confirmed = !ORDER.products[i].confirmed
            }
        }

        this.setState({ ORDER: ORDER })
    }

    renderCheckbox = (PRODUCT) => {
        return (
            <input
                key={ PRODUCT.id + '_checkbox' }
                id={ PRODUCT.id + '_checkbox' }
                type="checkbox"
                onChange={ () => this.toggleConfirmation(PRODUCT.id) }
                checked={ PRODUCT.confirmed }
            />
        )
    }

    renderProductsRows = (SAVEABLE) => {
        let ROWS = [];
        for (let i = 0; i < this.state.ORDER.products.length; i++) {
            let PRODUCT = this.state.ORDER.products[i];
            let numb = i + 1;

            ROWS.push(
                <tr key={ i }>
                    <td className="center" style={ SAVEABLE ? { borderBottom: 'solid 1px #000000' } : {} }>{ numb }{ SAVEABLE ? null : this.renderProductChecbox(PRODUCT) }</td>
                    { typeof SAVEABLE == "undefined" ? <td className="cell-center"><a target="_blank" href={ "https://ecomarket.ru/" + PRODUCT.url + ".html" }>{ this.renderImage(PRODUCT) }</a></td> : null }
                    <td style={ SAVEABLE ? { borderBottom: 'solid 1px #000000' } : {} }><span className="product_title">{ PRODUCT.title }</span></td>
                    <td style={ SAVEABLE ? { borderBottom: 'solid 1px #000000' } : {} }><span className="product_title">{ PRODUCT.vendor_code }</span></td>
                    <td className="cell-center" style={ SAVEABLE ? { borderBottom: 'solid 1px #000000' } : {} }>{ PRODUCT.barcode }</td>
                    { typeof SAVEABLE == "undefined" ? <td className="cell-center">{ PRODUCT.amount } { PRODUCT.ed_izm }</td> : null }
                    { typeof SAVEABLE == "undefined" ? <td className="cell-center">
                        { this.state.ORDER.status < 2 ?
                            <input
                                key={ PRODUCT.id + '_supplier_amount' }
                                type="number"
                                min="0"
                                onChange={ input => this.changeAmount(input.target.value, PRODUCT.id) }
                                defaultValue={ PRODUCT.supplier_amount }
                            /> : PRODUCT.supplier_amount + ' ' + PRODUCT.ed_izm }
                    </td> : null }
                    { typeof SAVEABLE == "undefined" ? <td className="cell-center">{ PRODUCT.price } руб</td> : null }
                    { typeof SAVEABLE == "undefined" ? <td className="cell-center">
                        { this.state.ORDER.status < 2 ?
                            <input
                                key={ PRODUCT.id + '_supplier_price' }
                                type="number"
                                min="0"
                                onChange={ input => this.changePrice(input.target.value, PRODUCT.id) }
                                defaultValue={ PRODUCT.supplier_price }
                            />
                            : PRODUCT.supplier_price + ' руб' }
                    </td> : null }

                    { typeof SAVEABLE == "undefined" ? null : <td className="cell-center" style={ SAVEABLE ? { borderBottom: 'solid 1px #000000' } : {} }>{ PRODUCT.supplier_amount }</td> }
                    { typeof SAVEABLE == "undefined" ? null : <td className="cell-center" style={ SAVEABLE ? { borderBottom: 'solid 1px #000000' } : {} }>{ PRODUCT.ed_izm }</td> }
                    { typeof SAVEABLE == "undefined" ? null : <td className="cell-center" style={ SAVEABLE ? { borderBottom: 'solid 1px #000000' } : {} }>{ PRODUCT.supplier_price }</td> }

                    <td className="cell-center" style={ SAVEABLE ? { borderBottom: 'solid 1px #000000' } : {} }>
                        { (PRODUCT.supplier_price * PRODUCT.supplier_amount).toFixed(2) }
                    </td>
                    { typeof SAVEABLE == "undefined" ?
                        this.state.ORDER.status < 2 ?
                            <td className="cell-center">
                                { this.renderCheckbox(PRODUCT) }
                            </td>
                            : null
                        : null }
                </tr>
            );
        }

        return (
            <tbody>
                { ROWS }
            </tbody>
        );
    }

    allSelect = () => {
        if (this.state.PRINT_PRODUCTS.length == this.state.ORDER.products.length) {
            this.setState({ PRINT_PRODUCTS: [] })
        } else {
            let NEW_PRINT_PRODUCTS = []
            for (let i = 0; i < this.state.ORDER.products.length; i++) {
                NEW_PRINT_PRODUCTS.push(this.state.ORDER.products[i])
            }
            this.setState({ PRINT_PRODUCTS: NEW_PRINT_PRODUCTS })
        }
    }

    singleSelect = (product) => {
        const added = this.state.PRINT_PRODUCTS.find(printProduct => {
            return printProduct.id == product.id
        })
        let NEW_PRINT_PRODUCTS = []
        if (added) {
            NEW_PRINT_PRODUCTS = this.state.PRINT_PRODUCTS.filter(printProduct => {
                return printProduct.id !== product.id
            })
        } else {
            NEW_PRINT_PRODUCTS = [...this.state.PRINT_PRODUCTS]
            NEW_PRINT_PRODUCTS.push(product)
        }

        this.setState({ PRINT_PRODUCTS: NEW_PRINT_PRODUCTS })
    }

    renderAllCheckbox = () => {
        if (parseInt(this.state.ORDER.status) !== 2) {
            return null
        }

        return (
            <div>
                <input type="checkbox" value="1" checked={ this.state.PRINT_PRODUCTS.length == this.state.ORDER.products.length } onChange={ () => this.allSelect() } />
            </div>
        )
    }

    renderProductChecbox = (product) => {
        if (parseInt(this.state.ORDER.status) !== 2) {
            return null
        }
        const added = this.state.PRINT_PRODUCTS.find(printProduct => {
            return printProduct.id == product.id
        })

        return (
            <div>
                <input type="checkbox" value="1" checked={ added } onChange={ () => this.singleSelect(product) } />
            </div>
        )
    }

    renderProductsTableHeader = (SAVEABLE) => {
        return (
            <thead>
                <tr>
                    <th>№{ SAVEABLE ? null : this.renderAllCheckbox() }</th>
                    { typeof SAVEABLE == "undefined" ? <th>фото</th> : null }
                    <th>наименование</th>
                    <th>артикул</th>
                    <th>штрихкод</th>
                    { typeof SAVEABLE == "undefined" ? <th>желаемое количество</th> : null }
                    { typeof SAVEABLE == "undefined" ? <th>ваше кол-во</th> : null }
                    { typeof SAVEABLE == "undefined" ? <th>желаемая цена</th> : null }
                    { typeof SAVEABLE == "undefined" ? <th>ваша цена</th> : null }

                    { typeof SAVEABLE == "undefined" ? null : <th>количество</th> }
                    { typeof SAVEABLE == "undefined" ? null : <th>ед изм</th> }
                    { typeof SAVEABLE == "undefined" ? null : <th>цена</th> }

                    <th>сумма</th>
                    { typeof SAVEABLE == "undefined" ? null : this.state.ORDER < 2 ? <th>под-ние</th> : null }
                </tr>
            </thead>
        );
    }

    renderProducts = () => {
        return (
            <div className="table_holder">
                <table id="products_table" className="products_table" cellPadding="0" cellSpacing="0">
                    { this.renderProductsTableHeader() }
                    { this.renderProductsRows() }
                </table>
                <div style={ { display: 'none' } }>
                    <div id="printableArea">
                        <table id="products_table_saveable" className="products_table_saveable" cellPadding="3" cellSpacing="0">
                            <thead>
                                <tr>
                                    <td colSpan={ 2 }>
                                        Дата заказа:
                                    </td>
                                    <td colSpan={ 2 }>
                                        { this.state.ORDER.order_date }
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={ 2 }>
                                        Дата поставки:
                                    </td>
                                    <td colSpan={ 2 }>
                                        { this.state.ORDER.delivery_date }
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={ 2 }>
                                        Время поставки:
                                    </td>
                                    <td colSpan={ 2 }>
                                        { this.state.ORDER.delivery_time }
                                    </td>
                                </tr>
                                {
                                    this.state.ORDER.comment.length ?
                                        <tr>
                                            <td colSpan={ 2 }>
                                                Комментарий:
                                            </td>
                                            <td colSpan={ 2 }>
                                                { this.state.ORDER.comment }
                                            </td>
                                        </tr>
                                        : null
                                }
                                <tr>
                                    <td></td><td></td>
                                </tr>
                            </thead>
                            { this.renderProductsTableHeader(true) }
                            { this.renderProductsRows(true) }
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    countOrder = () => {
        let sum = 0;
        let amount = 0;

        for (let i = 0; i < this.state.ORDER.products.length; i++) {
            if (this.state.ORDER.products[i].confirmed) {
                amount++;
                sum += this.state.ORDER.products[i].supplier_amount * this.state.ORDER.products[i].supplier_price;
            }
        }

        return {
            amount: amount,
            sum: sum
        }
    }

    changeDeliveryDate = (date) => {
        let ORDER = Object.assign({}, this.state.ORDER)

        ORDER.delivery_date = date;

        this.setState({ ORDER: ORDER })
    }

    changeDeliveryTime = (date) => {
        let ORDER = Object.assign({}, this.state.ORDER)

        ORDER.delivery_time = date;

        this.setState({ ORDER: ORDER })
    }

    getClass = (amount) => {
        if (amount == 0) {
            return 'inactive'
        }

        return ''
    }

    selectOrDeselectAll = () => {
        let totals = this.countOrder();
        let ORDER = Object.assign({}, this.state.ORDER)

        for (let i = 0; i < ORDER.products.length; i++) {
            if (totals.amount == this.state.ORDER.products.length) {
                ORDER.products[i].confirmed = false
            } else {
                ORDER.products[i].confirmed = true
            }
        }

        this.setState({ ORDER: ORDER })
    }

    renderCancelButton = () => {
        if (this.state.ORDER.status == 0 || this.state.ORDER.status == 1 || this.state.ORDER.status == 2) {
            return (
                <a className="cancel_supplier_order" onClick={ () => this.cancelOrder() }>Отменить заказ</a>
            )
        }

        return null
    }

    num_title = (n, titles) => {
        return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];
    }

    renderDeliveryTimeOptions = () => {
        let options = []
        for (let i = 4; i < 22; i++) {
            let local_start = i;
            let local_end = i + 1;

            if (local_start < 10) {
                local_start = '0' + local_start
            }
            if (local_end < 10) {
                local_end = '0' + local_end
            }

            let string = local_start + ':00-' + local_end + ':00';
            options.push(<option key={ i } value={ string }>{ string }</option>)
        }

        return options;
    }

    renderTotalsBlock = () => {
        let totals = this.countOrder();

        return (
            <div className="ordering_confirm_total">
                <div>
                    <span>Заказ:</span>
                    <span>{ totals.amount } { this.num_title(totals.amount, ['позиция', 'позиции', 'позиций']) }</span>
                </div>
                <div>
                    <span>Сумма:</span>
                    <span>{ totals.sum.toFixed(2) } руб</span>
                </div>
                { this.state.ORDER.status < 2 ?
                    <>
                        <div>
                            <span>Дата доставки:</span>
                            <span>
                                <input
                                    type="date"
                                    name="delivery_date"
                                    onChange={ (input) => this.changeDeliveryDate(input.target.value) }
                                    value={ this.state.ORDER.delivery_date }
                                />
                            </span>
                        </div>
                        <div>
                            <span>Время доставки:</span>
                            <span>
                                <select
                                    name="delivery_time"
                                    onChange={ (select) => this.changeDeliveryTime(select.target.value) }
                                    value={ this.state.ORDER.delivery_time }
                                >
                                    { this.renderDeliveryTimeOptions() }
                                </select>
                            </span>
                        </div>
                        <a className="ordering_confirm_btn" onClick={ () => this.selectOrDeselectAll() }>
                            { totals.amount == this.state.ORDER.products.length ? 'Отменить выбор' : 'Выбрать все' }
                        </a>
                        <a className={ 'submit_order_to_suppliers ' + this.getClass(totals.amount) } onClick={ () => totals.amount > 0 ? this.saveOrderData() : alert('Необходимо подтвердить товары в заказе') }>
                            { this.state.ORDER.status < 1 ? 'Согласовать' : 'Обновить' }
                        </a>
                    </> : null }
                { this.renderXlsButton() }
                { this.renderPrintBtn() }
                { this.state.ORDER.status < 2 ?
                    this.renderCancelButton()
                    : null }
            </div>
        )
    }

    renderPrintBtn = () => {
        if (this.state.LOADED) {
            if (parseInt(this.state.ORDER.status) !== 3) {
                return (
                    <a className="print_btn" onClick={ () => this.printOrder() }>Печать</a>
                )
            }
        }
    }

    renderXlsButton = () => {
        if (this.state.LOADED) {
            if (parseInt(this.state.ORDER.status) !== 3) {
                return (
                    <ReactHTMLTableToExcel
                        id="products_table_btn"
                        className="filter_btn_list"
                        table="products_table_saveable"
                        filename={ 'Заказ ' + this.state.ORDER.id }
                        sheet="ecomarket_products"
                        buttonText="Сохранить в XLS"
                    />
                );
            }
        }
    }

    printOrder = () => {
        var prtContent = document.getElementById("printableArea");
        var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
        WinPrint.document.write(prtContent.innerHTML);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        if (!this.state.LOADED) {
            return (
                <div className="main_content">
                    <Helmet>
                        <title>Заказ</title>
                    </Helmet>
                    <h1>Заказ</h1>
                    <div className="table_holder"><Loader /><div className="loader_content">Загружаем данные по заказу ...</div></div>
                </div>
            );
        }

        if (!this.state.ORDER) {
            return (
                <div className="main_content">
                    <Helmet>
                        <title>Заказ</title>
                    </Helmet>
                    <h1>Заказ</h1>
                    <div className="table_holder">К сожалению, данных по заказу не найдено...</div>
                </div>
            );
        } else {
            return (
                <div className="main_content">
                    <Helmet>
                        <title>Заказ №{ this.state.ORDER.id } от { this.state.ORDER.order_date }</title>
                    </Helmet>
                    <h1>Заказ №{ this.state.ORDER.id } от { this.state.ORDER.order_date }</h1>
                    { this.renderIntroBlock() }
                    <div className="order_data_block">
                        { this.renderProducts() }
                        { this.renderTotalsBlock() }
                    </div>
                </div>
            );
        }
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Order))
